import { Alert, Typography } from '@mui/material';

type Props = {
  errorText: React.ReactNode;
  actionText?: React.ReactNode;
};

export const ErrorMessage: React.FC<Props> = ({
  errorText,
  actionText = 'Please try again.',
}) => {
  return (
    <Alert
      severity="error"
      variant="outlined"
      sx={{
        backgroundColor: '#FEECEC',
        color: 'error.main',
        border: '1px solid #FCCFCF',
        width: '100%',
        transition: 'all 0.5s ease',
      }}
    >
      <Typography variant="body2">{errorText}</Typography>
      <Typography variant="body2">{actionText}</Typography>
    </Alert>
  );
};
